module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4n5r1n2r-3cfd389ae906e76a243a38ea6708580d.svg";